package com.merkost.handpass.admin.contract

import com.merkost.handpass.api.dto.admin.AdminConversationMessage
import com.merkost.handpass.api.dto.admin.AdminConversationSummary
import com.merkost.handpass.api.dto.admin.AdminNote
import com.merkost.handpass.api.dto.admin.AdminUserDetail
import com.merkost.handpass.api.dto.admin.AuditEntry
import com.merkost.handpass.api.dto.admin.BanPreviewResponse
import pro.respawn.flowmvi.api.MVIAction
import pro.respawn.flowmvi.api.MVIIntent
import pro.respawn.flowmvi.api.MVIState

sealed interface UserDetailState : MVIState {
    data object Loading : UserDetailState
    data class Content(
        val detail: AdminUserDetail,
        val activeTab: UserDetailTab = UserDetailTab.Listings,
        val suspendDays: Int = 7,
        val notes: AsyncSection<List<AdminNote>> = AsyncSection.Loading,
        val audit: AsyncSection<List<AuditEntry>> = AsyncSection.Loading,
        val newNoteDraft: String = "",
        val conversations: AsyncSection<List<AdminConversationSummary>> = AsyncSection.Loading,
        val conversationsRequested: Boolean = false,
        val openConversation: AdminConversationSummary? = null,
        val messages: AsyncSection<List<AdminConversationMessage>> = AsyncSection.Loading,
    ) : UserDetailState
    data class Error(val message: String) : UserDetailState
}

enum class UserDetailTab { Listings, Reports, History, Notes, Conversations, ViewedBy }

sealed interface UserDetailIntent : MVIIntent {
    data class Init(val userId: String) : UserDetailIntent
    data class SetTab(val tab: UserDetailTab) : UserDetailIntent
    data class SetSuspendDays(val days: Int) : UserDetailIntent
    data object TapWarn : UserDetailIntent
    data object TapSuspend : UserDetailIntent
    data object TapBan : UserDetailIntent
    data object TapRestore : UserDetailIntent
    data class ConfirmAction(val kind: UserDetailActionKind, val reason: String?) : UserDetailIntent
    data class UndoRestore(val userId: String) : UserDetailIntent
    data object Refresh : UserDetailIntent
    data class SetNoteDraft(val body: String) : UserDetailIntent
    data object SubmitNote : UserDetailIntent
    data class DeleteNote(val noteId: String) : UserDetailIntent
    data object LoadConversations : UserDetailIntent
    data class OpenConversation(val conversation: AdminConversationSummary) : UserDetailIntent
    data object CloseConversation : UserDetailIntent
}

enum class UserDetailActionKind { Warn, Suspend, Ban, Restore }

sealed interface UserDetailAction : MVIAction {
    data class OpenReasonModal(
        val kind: UserDetailActionKind,
        val targetName: String,
        val banPreview: BanPreviewResponse? = null,
    ) : UserDetailAction
    data class Navigate(val path: String) : UserDetailAction
    data class ShowSuccess(val message: String) : UserDetailAction
    data class ShowUndoableSuccess(val message: String, val userId: String) : UserDetailAction
    data class ShowError(val message: String) : UserDetailAction
}
